import React from 'react';

import type { Props } from '../types/PageLoadEndProps.ts';

import { UFOLoadEnd } from './UFOLoadEnd.tsx';

/**
 * Component that calls addUFOCustomData directly for page load end.
 */
export const PageLoadEnd = (props: Props) => {
	return <UFOLoadEnd {...props} />;
};
